import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturesBar from '../components/home/FeaturesBar';
import CategoriesSection from '../components/home/CategoriesSection';
import PacksSection from '../components/home/PacksSection';
import ProductsSection from '../components/home/ProductsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <FeaturesBar />
      <CategoriesSection />
      <PacksSection />
      <ProductsSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
